export const cardGridDimensions = { xs: 12, sm: 6, md: 4, lg: 4, xl: 4 };
export const largeCardGridDimensions = { xs: 12, sm: 12, md: 8, lg: 8, xl: 8 };
export const maxCardGridDimensions = { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 };
